import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import { IBannerModel } from '@shared/models/alerts/IBannerModel';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const getOnLineStatus = () =>
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;

export default function useNetworkStatusBanner() {
    const { addBanner, removeBanner } = AlertsContainer.useContainer();
    const { t } = useTranslation();
    const [status, setStatus] = useState(getOnLineStatus());

    const setOnline = () => setStatus(true);
    const setOffline = () => setStatus(false);

    const handleOffline = useCallback(() => {
        const offlineBanner: IBannerModel = {
            id: 'offline',
            icon: 'connectionOffline',
            title: t('common:wifi.disconnected'),
            subtitle: t('common:wifi.description'),
            color: 'error',
        };
        addBanner(offlineBanner);
    }, [addBanner, t]);

    const handleOnline = useCallback(() => {
        removeBanner('offline');
    }, [removeBanner]);

    useEffect(() => {
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);

        return () => {
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, []);

    useEffect(() => {
        if (status) {
            handleOnline();
        } else {
            handleOffline();
        }
    }, [status]);
}
